const areas = {
  dg: {
    appId: 'wx20e45e2adf94aa74',
    componentAppId: '',
    codeTitle: '扫码添加官方客服',
    codeSubTitle: '获取更多楼盘优惠及详情！',
    codeImage: '/dg3/static/assets/code-dg.jpg',
    initPopupCode: true,
  },
  dev: {
    appId: 'wxb638db3786365c83',
    componentAppId: '',
    codeTitle: '扫码添加官方客服',
    codeSubTitle: '获取更多楼盘优惠及详情！',
    codeImage: '/dg3/static/assets/code-dg.jpg',
    initPopupCode: true,
  }
}

const host = window.location.host
const currentArea = process.env.NODE_ENV === 'production' ? host.split('.')[0] : 'dg'

export default Object.assign({ id: currentArea }, areas[currentArea])